import { render, staticRenderFns } from "./AboutPP.vue?vue&type=template&id=a7aac6c0&scoped=true"
import script from "./AboutPP.vue?vue&type=script&lang=js"
export * from "./AboutPP.vue?vue&type=script&lang=js"
import style0 from "./AboutPP.vue?vue&type=style&index=0&id=a7aac6c0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7aac6c0",
  null
  
)

export default component.exports